import { render, staticRenderFns } from "./Html.vue?vue&type=template&id=edb6f482&scoped=true&"
import script from "./Html.vue?vue&type=script&lang=js&"
export * from "./Html.vue?vue&type=script&lang=js&"
import style0 from "./Html.vue?vue&type=style&index=0&id=edb6f482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6f482",
  null
  
)

export default component.exports